import type { RouteLocationRaw } from "vue-router";
import { extractTenantId } from "./tenantHelper";

type NullableRecord = Record<string, unknown> | null | undefined;

export function buildDoctorProfileRoute(
  doctor: NullableRecord,
): RouteLocationRaw | null {
  if (!doctor) {
    return null;
  }

  const doctorId = doctor.id ?? (doctor as Record<string, unknown>).resourceId;
  if (doctorId === undefined || doctorId === null) {
    return null;
  }

  const candidateTenantId = (doctor as Record<string, unknown>).tenantId as
    | string
    | undefined;
  const derivedTenantId =
    candidateTenantId ??
    extractTenantId(
      (doctor as Record<string, unknown>).tenantXId as string | null,
    );

  if (!derivedTenantId) {
    return null;
  }

  // Prefer the public slug URL (/sara-rey) for SEO. Fallback to the legacy
  // /profile/:tenantId/:id when the doctor has no slug yet.
  const slug = (doctor as Record<string, unknown>).slug;
  if (typeof slug === "string" && slug.length > 0) {
    return { path: `/${slug}` };
  }

  return {
    name: "Profile",
    params: {
      tenantId: derivedTenantId,
      id: String(doctorId),
    },
  };
}
